var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"IIIFFragment"},[_c('figure',{staticClass:"position-relative IIIFFragment overflow-hidden",on:{"click":e => _vm.$emit('click', e)}},[_c('img',{staticClass:"shadow-sm",attrs:{"src":_vm.imageUrl,"alt":"IIIF Fragment"}}),_c('div',{staticClass:"IIIFFragment__regions",style:(_vm.computedRegionsStyle)},_vm._l((_vm.computedRegions),function(region){return _c('div',{key:region.id,staticClass:"IIIFFragment__region position-absolute",style:({
          top: `${region.y}%`,
          left: `${region.x}%`,
          width: `${region.w}%`,
          height: `${region.h}%`,
        })})}),0)])])
}
var staticRenderFns = []

export { render, staticRenderFns }